export default "__VITE_ASSET__t0fDuRkS__"